<script setup lang="ts">
    import { NavigationMenuTrigger } from 'radix-vue'
    import { injectSiteNavRootContext } from './site-nav-root.vue'
    import { injectSiteNavItemContext } from './site-nav-item.vue'

    const root = injectSiteNavRootContext()!
    const item = injectSiteNavItemContext()!

    function onTouchEnd(event: TouchEvent) {
        if (root.active.value !== item.value.value)
            event.currentTarget.addEventListener('click', (event) => event.preventDefault(), { once: true })
    }
</script>
<template>
    <a v-if="root.type.value === 'accordion'">
        <slot />
    </a>
    <NavigationMenuTrigger as="a" @touchend="onTouchEnd" v-else>
        <slot />
    </NavigationMenuTrigger>
</template>